var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 33,
    viewBox: "0 0 70 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1258 0H0V10.8425H35.3213C33.0437 7.35129 30.9041 3.77981 29.1258 0Z",
    fill: "url(#paint0_linear_4915_3774)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1967 18.0673C38.5578 15.6681 36.9073 13.2742 35.32 10.8428H0V21.6853H42.6008C41.8111 20.4728 41.0149 19.2642 40.198 18.0673H40.1967Z",
    fill: "url(#paint1_linear_4915_3774)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6008 21.6836H0V32.5261H49.479C47.182 28.9145 44.9353 25.2706 42.6008 21.6836Z",
    fill: "url(#paint2_linear_4915_3774)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9258 0L61.6071 32.5263H65.5792C68.0207 32.5263 70.0003 30.5413 70.0003 28.093L49.4948 0H37.9258Z",
    fill: "#01BAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9995 4.43329C69.9995 1.98502 68.0199 0 65.5783 0H55.9102L70.0007 19.352V4.43329H69.9995Z",
    fill: "#01BAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4395 0L43.9246 32.5263H55.2472L31.5039 0H20.4395Z",
    fill: "#01BAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4915_3774",
    x1: 0,
    y1: 5.42062,
    x2: 22.4464,
    y2: 5.42062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4915_3774",
    x1: 4.63793,
    y1: 16.2634,
    x2: 35.7485,
    y2: 16.2634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4915_3774",
    x1: 13.204,
    y1: 27.1055,
    x2: 57.7264,
    y2: 27.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3255c8e5c606bb7b900cceab4169d5b4.svg";
export { ForwardRef as ReactComponent };